/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CapitalizePipe } from '@hmax-order/frontend/utils';
import { TranslocoModule } from '@jsverse/transloco';
import { ActionButtonMenu } from '../interfaces';

@Component({
  selector: 'hmax-button-menu',
  standalone: true,
  templateUrl: './button-menu.component.html',
  styleUrls: ['./button-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatMenuModule, MatIconModule, MatButtonModule, CapitalizePipe, TranslocoModule],
})
export class ButtonMenuComponent {
  /*
   * ⚠️ Era `Eager` (o antigo `Default`). Com `provideZoneChangeDetection()` no app, TODO evento de
   * DOM dispara um ciclo global de verificação, e um componente `Eager` é revisitado em cada um
   * deles. Isso é irrelevante nas duas telas em que ele aparece uma vez (tabela e produtos), mas o
   * painel de pedidos renderiza **um por card**: abrir o dropdown ou trocar de aba dispara uma rajada
   * de eventos, e cada evento passava a revisitar vinte subárvores com menu dentro.
   *
   * `OnPush` é seguro aqui: o componente só lê `@Input`s e emite um `@Output`, sem estado mutável
   * próprio. Os dois consumidores passam arrays de ação declarados como campo de classe e **nunca**
   * mutados no lugar (verificado), então não existe atualização a perder.
   */
  @Input() label = '';
  @Input() type: 'basic' | 'raised' | 'stroked' | 'flat' | 'icon' | 'fab' | 'mini-fab' = 'stroked';
  @Input() color: 'basic' | 'primary' | 'accent' | 'warn' | 'disabled' | 'link' = 'basic';
  @Input() icon!: string;
  /**
   * Ícone DEPOIS do rótulo, sempre visível — a seta de dropdown do padrão do HMAX Web.
   *
   * Separado do `icon` porque aquele é ícone de identidade da ação: vem antes do texto e **esconde o
   * rótulo no celular** (`hidden sm:block`). Uma seta de dropdown que desaparece no celular deixa o
   * botão sem indicar que abre menu, e um rótulo que desaparece deixa o operador sem saber o estado.
   */
  @Input() trailingIcon?: string;
  @Input() actions?: ActionButtonMenu[];
  @Input() class = '';
  @Input() disabled = false;

  @Output() optionClick = new EventEmitter<any>();

  /**
   * Opção selecionada
   * @param method nome do método a ser acionado
   * @param index índice da opção selecionada
   * @param option dados da opção selecionada (visíveis ou não)
   */
  doOptionClick(method: string, index: number, option: any): void {
    const optionData = { ...option, method, index };
    this.optionClick.emit(optionData);
  }
}
